<template>
    <div>
        <p class="text-small font-weight-light text-grey-darken-1" v-html="text"></p>
    </div>
</template>

<script>
export default {
    props: {
      plugin: {
        required: true
      }
    },
    computed: {
        text() {
            return this.plugin.permissions.replaceAll('\n', '</br>');
        }
    }
};
</script>
